// Mock temperature data for TemperatureChart (matching the attached design)
export const temperatureData = [
    { month: "12/04 00:00", temperature: 5, alarms: [] },
    { month: "12/04 04:00", temperature: 8, alarms: [] },
    { month: "12/04 08:00", temperature: 15, alarms: [] },
    { month: "12/04 12:00", temperature: 25, alarms: [] },
    { month: "12/04 16:00", temperature: 35, alarms: [] },
    { month: "12/04 20:00", temperature: 45, alarms: [] },
    { month: "13/04 00:00", temperature: 50, alarms: [] },
    { month: "13/04 04:00", temperature: 55, alarms: [] },
    { month: "13/04 08:00", temperature: 60, alarms: [] },
    { month: "13/04 12:00", temperature: 65, alarms: [] },
    { month: "13/04 16:00", temperature: 70, alarms: [] },
    {
        month: "13/04 20:00",
        temperature: 72,
        alarms: [{ type: "high_temp", message: "High temperature alert" }],
    },
    {
        month: "14/04 00:00",
        temperature: 75,
        alarms: [{ type: "high_temp", message: "High temperature alert" }],
    },
    {
        month: "14/04 04:00",
        temperature: 78,
        alarms: [{ type: "high_temp", message: "High temperature alert" }],
    },
    {
        month: "14/04 08:00",
        temperature: 80,
        alarms: [{ type: "high_temp", message: "High temperature alert" }],
    },
    {
        month: "14/04 12:00",
        temperature: 82,
        alarms: [{ type: "high_temp", message: "High temperature alert" }],
    },
    {
        month: "14/04 16:00",
        temperature: 80,
        alarms: [{ type: "high_temp", message: "High temperature alert" }],
    },
    { month: "14/04 20:00", temperature: 78, alarms: [] },
    { month: "15/04 00:00", temperature: 75, alarms: [] },
    { month: "15/04 04:00", temperature: 70, alarms: [] },
    { month: "15/04 08:00", temperature: 65, alarms: [] },
    { month: "15/04 12:00", temperature: 60, alarms: [] },
    { month: "15/04 16:00", temperature: 55, alarms: [] },
    { month: "15/04 20:00", temperature: 50, alarms: [] },
    { month: "16/04 00:00", temperature: 45, alarms: [] },
    { month: "16/04 04:00", temperature: 42, alarms: [] },
    { month: "16/04 08:00", temperature: 40, alarms: [] },
    { month: "16/04 12:00", temperature: 38, alarms: [] },
    { month: "16/04 16:00", temperature: 35, alarms: [] },
    { month: "16/04 20:00", temperature: 32, alarms: [] },
    { month: "17/04 00:00", temperature: 30, alarms: [] },
    { month: "17/04 04:00", temperature: 28, alarms: [] },
    { month: "17/04 08:00", temperature: 25, alarms: [] },
    { month: "17/04 12:00", temperature: 22, alarms: [] },
    { month: "17/04 16:00", temperature: 20, alarms: [] },
    { month: "17/04 20:00", temperature: 18, alarms: [] },
    { month: "18/04 00:00", temperature: 15, alarms: [] },
    { month: "18/04 04:00", temperature: 12, alarms: [] },
    { month: "18/04 08:00", temperature: 10, alarms: [] },
    { month: "18/04 12:00", temperature: 8, alarms: [] },
];
// Mock temperature log data
export const temperatureLogData = [
    { id: 1, dateTime: "29-07-25 13:00:00", temperature: "24.2 °C" },
    { id: 2, dateTime: "29-07-25 14:15:00", temperature: "25.1 °C" },
    { id: 3, dateTime: "29-07-25 15:30:00", temperature: "23.9 °C" },
    { id: 4, dateTime: "29-07-25 18:00:00", temperature: "26.8 °C" },
    { id: 5, dateTime: "29-07-25 19:15:00", temperature: "22.4 °C" },
    { id: 6, dateTime: "29-07-25 20:30:00", temperature: "21.9 °C" },
    { id: 7, dateTime: "29-07-25 21:45:00", temperature: "23.3 °C" },
    { id: 8, dateTime: "29-07-25 23:00:00", temperature: "25.7 °C" },
    { id: 9, dateTime: "30-07-25 00:15:00", temperature: "24.8 °C" },
    { id: 10, dateTime: "29-07-25 16:45:00", temperature: "24.5 °C" },
    { id: 11, dateTime: "30-07-25 01:30:00", temperature: "26.1 °C" },
];
// Mock event log data
export const eventLogData = [
    {
        id: 1,
        dateTime: "29-07-25 13:00:00",
        statusType: "1",
        flag: "TempHigh",
        battery: "3664 mVh",
        rssi: -70,
        version: 20,
        debug: null,
        temperature: "51.2 °C",
    },
    {
        id: 2,
        dateTime: "29-07-25 13:30:00",
        statusType: "1",
        flag: "PowerOn",
        battery: "3700 mVh",
        rssi: -65,
        version: 20,
        debug: null,
        temperature: "25.1 °C",
    },
    {
        id: 3,
        dateTime: "29-07-25 13:25:00",
        statusType: "0",
        flag: "PowerOff",
        battery: "3650 mVh",
        rssi: -72,
        version: 20,
        debug: null,
        temperature: "N/A",
    },
    {
        id: 4,
        dateTime: "29-07-25 13:35:00",
        statusType: "0",
        flag: "SwitchClosed",
        battery: "3680 mVh",
        rssi: -68,
        version: 20,
        debug: null,
        temperature: "23.5 °C",
    },
    {
        id: 5,
        dateTime: "29-07-25 13:15:00",
        statusType: "0",
        flag: "TempLow",
        battery: "3632 mVh",
        rssi: -75,
        version: 20,
        debug: null,
        temperature: "-26.4 °C",
    },
    {
        id: 6,
        dateTime: "29-07-25 13:20:00",
        statusType: "1",
        flag: "SwitchOpen",
        battery: "3700 mVh",
        rssi: -60,
        version: 20,
        debug: null,
        temperature: "22.0 °C",
    },
    {
        id: 7,
        dateTime: "29-07-25 13:10:00",
        statusType: "1",
        flag: "None",
        battery: "3720 mVh",
        rssi: -55,
        version: 20,
        debug: null,
        temperature: "24.8 °C",
    },
    {
        id: 8,
        dateTime: "29-07-25 13:05:00",
        statusType: "0",
        flag: "None",
        battery: "3690 mVh",
        rssi: -62,
        version: 20,
        debug: null,
        temperature: "21.2 °C",
    },
];
export const deviceOptions = [
    { label: "Koelvak 1", value: "koelvak_1" },
    { label: "Vriesvak A", value: "vriesvak_a" },
    { label: "Koelcel 2", value: "koelcel_2" },
];
